var exports = {
  "wrapper": "x936d19a0--4ac85c--wrapper",
  "container": "x936d19a0--4ac85c--container",
  "phone": "x936d19a0--4ac85c--phone",
  "title": "x936d19a0--4ac85c--title",
  "text": "x936d19a0--4ac85c--text",
  "image": "x936d19a0--4ac85c--image",
  "tablet": "x936d19a0--4ac85c--tablet",
  "footer": "x936d19a0--4ac85c--footer",
  "chat-action": "x936d19a0--4ac85c--chat-action",
};

module.exports = exports;
